module.exports = __webpack_public_path__ + "img/bus-stop.07c6ff54.svg";